import * as actions from './actions'
import reducer from './reducer'
import withNotifications from './components/withNotifications'
import Notifications from './components/Notifications'
import * as actionTypes from './actionTypes'

export default actions

export { reducer, withNotifications, Notifications, actionTypes }


// WEBPACK FOOTER //
// ./src/modules/notification/index.js